export const IS_BROWSER = typeof window !== 'undefined'
const environmentMap = {
  dev: 'dev', // default
  localhost: 'dev', // localhost
  classesdev: 'dev', // classesdev.tivityhealth.com
  classesqa: 'qa', // classesqa.tivityhealth.com
  classesuat: 'uat', // classesuat.tivityhealth.com
  // PROD
  classes: '', // classes.tivityhealth.com
}
export const HOST_NAME = IS_BROWSER
  ? window.location.hostname.split('.')[0]
  : 'localhost'

export const HOST_CODE = IS_BROWSER
  ? environmentMap[HOST_NAME]
  : environmentMap.dev

// TODO: replace with generic help email address
export const SUPPORT_EMAIL = 'brent.larson@tivityhealth.com'

export const HOST_CODE_KEY = HOST_CODE !== '' ? HOST_CODE : 'prod'

export const API_URL = `https://${HOST_CODE}api.livebetterchoices.com/api`
